import { ReactNode } from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { Tooltip } from '@/components/lemmala-design-system/tooltip/tooltip'

import { useIsTruncated } from './use-is-truncated'

type TruncatedTextProps = {
  text: string
  className?: string
  children?: ReactNode
  /** Shown on hover even when the visible text fits. */
  detail?: string
}

// The trigger stays mounted so the measured node is the same one the ellipsis clips.
export const TruncatedText = ({ text, className, children, detail }: TruncatedTextProps) => {
  const { ref, isTruncated } = useIsTruncated(text)
  const hiddenDetail = detail && detail !== text ? detail : undefined
  const showTooltip = isTruncated || Boolean(hiddenDetail)

  return (
    <Tooltip
      asChild
      triggerClassName='block min-w-0 w-full'
      size='large'
      trigger={
        <span
          ref={ref}
          tabIndex={showTooltip ? 0 : undefined}
          className={cn('block w-full min-w-0 truncate text-left', className)}
          data-testid='truncated-text'
        >
          {children ?? text}
        </span>
      }
    >
      {showTooltip ? (
        <span className='flex flex-col gap-0.5 break-words'>
          {isTruncated ? <span>{text}</span> : null}
          {hiddenDetail ? <span>{hiddenDetail}</span> : null}
        </span>
      ) : null}
    </Tooltip>
  )
}
